import { Controller } from 'stimulus';
import MitreTable from '../utils/mitre-table';

export default class extends Controller {
  static targets = [
    'page',
    'leftArrow',
    'rightArrow',
    'first',
    'prev',
    'currentPage',
    'next',
    'last'
  ]

  initialize() {
    const tableKey = this.element.closest('[data-table-key-value]').getAttribute('data-table-key-value');
    this._mitreTable = MitreTable.getByTableKey(tableKey);
  }

  connect() {
    this._updatePaginationUI();
  }

  _updatePaginationUI() {
    this.__resetState();
    const totalPages = parseInt(this.data.get('total-pages'));
    const currentPage = parseInt(this.data.get('current-page'));
    if (currentPage == '1') {
      this.leftArrowTarget.disabled = true;
    } else {
      this.leftArrowTarget.disabled = false;
    }
    if (currentPage == totalPages) {
      this.rightArrowTarget.disabled = true;
    } else {
      this.rightArrowTarget.disabled = false;
    }
    this.currentPageTarget.textContent = currentPage;
    this.currentPageTarget.setAttribute('data-table-pagination-page', currentPage);
    this.lastTarget.textContent = totalPages;
    this.lastTarget.setAttribute('data-table-pagination-page', totalPages);
    this.firstTarget.textContent = '1';
    this.firstTarget.setAttribute('data-table-pagination-page', '1');
    if (parseInt(totalPages) < 4) {
      this.firstTarget.classList.add('t-hidden')
      this.prevTarget.classList.add('t-hidden')
      this.nextTarget.classList.add('t-hidden')
      this.lastTarget.classList.add('t-hidden')
      this.pageTargets.forEach((element, index) => {
        if (index < parseInt(totalPages)) {
          element.setAttribute('data-table-pagination-page', index + 1);
          element.textContent = index + 1;
        } else {
          element.classList.add('t-hidden')
        }
      });
    } else if (parseInt(totalPages) == 4) {
      this.firstTarget.classList.add('t-hidden')
      this.prevTarget.classList.add('t-hidden')
      this.nextTarget.classList.add('t-hidden')
      this.pageTargets.forEach((element, index) => {
        element.setAttribute('data-table-pagination-page', index + 1);
        element.textContent = index + 1;
      });
    } else {
      if (currentPage < 4) {
        this.prevTarget.classList.add('t-hidden');
        this.firstTarget.classList.add('t-hidden');
        this.pageTargets.forEach((element, index) => {
          element.setAttribute('data-table-pagination-page', index + 1);
          element.textContent = index + 1;
        });
        this.nextTarget.setAttribute('data-table-pagination-page', 4);
      } else if (totalPages - currentPage < 3) {
        this.nextTarget.classList.add('t-hidden');
        this.lastTarget.classList.add('t-hidden');
        this.pageTargets.forEach((element, index) => {
          element.setAttribute('data-table-pagination-page', totalPages - 2 + index);
          element.textContent = totalPages - 2 + index;
        });
        this.prevTarget.setAttribute('data-table-pagination-page', totalPages - 3);
      } else {
        this.pageTargets.forEach((element, index) => {
          element.setAttribute('data-table-pagination-page', currentPage - 1 + index );
          element.textContent = currentPage - 1 + index;
        });
        this.prevTarget.setAttribute('data-table-pagination-page', currentPage - 2);
        this.nextTarget.setAttribute('data-table-pagination-page', currentPage + 2);
      }
    }
    this.__updateCurrentPageState();
  }

  async select(e) {
    this._mitreTable.emit('interaction', { type: MitreTable.InteractionType.PAGE_CHANGE });
    if (MitreTable.areInteractionsLocked()) return;

    const page = e.target.getAttribute('data-table-pagination-page');
    this.__updateTableWithPage(page);
  }

  prevPage() {
    const currentPage = parseInt(this.data.get('current-page'));
    this.__updateTableWithPage(currentPage -1);
  }

  nextPage() {
    const currentPage = parseInt(this.data.get('current-page'));
    this.__updateTableWithPage(currentPage + 1);
  }

  __updateTableWithPage(page) {
    this.data.set('current-page', page);
    this._updatePaginationUI();

    this._mitreTable.emit('table-body-update', { pagination: page });
    this._mitreTable.emit('table-sticky-row-update');
  }

  __resetState() {
    this.firstTarget.classList.remove('t-hidden')
    this.prevTarget.classList.remove('t-hidden')
    this.nextTarget.classList.remove('t-hidden')
    this.lastTarget.classList.remove('t-hidden')
  }

  __updateCurrentPageState() {
    const currentPage = this.data.get('current-page');
    this.element.querySelectorAll('[data-table-pagination-page]').forEach(element => element.classList.remove('m-table-pagination-page-button__selected'))
    this.element.querySelector(`[data-table-pagination-page="${currentPage}"]:not(.t-hidden)`).classList.add('m-table-pagination-page-button__selected')
  }
}
